// Messages from the team (admin broadcasts) that arrive over a lobby socket
// ({t: "notice"}). The lobby hands them here; TeamNotices (mounted above every
// screen) shows them, together with the ones it polls from GET /api/me/notices.
import type { Notice } from "@wp/shared";

type Listener = (notice: Notice) => void;
const listeners = new Set<Listener>();

export function deliverNotice(notice: Notice): void {
  for (const l of listeners) l(notice);
}

export function onNotice(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
